angular.module('taric.footnote.view', ['taric.model.footnote'])
    .controller('ViewFootnoteController', function (footnote, CONSTANTS) {
        var viewFootnoteCtrl = this;

        viewFootnoteCtrl.init = function () {
            viewFootnoteCtrl.dateFormat = CONSTANTS.dateFormat;
            viewFootnoteCtrl.selectedRow = footnote;
            viewFootnoteCtrl.descriptionLanguages = [];
            if (viewFootnoteCtrl.selectedRow) {
                // Sort languages of additional code descriptions
                for (let lang in viewFootnoteCtrl.selectedRow.descriptions) {
                    viewFootnoteCtrl.descriptionLanguages.push(lang);
                }
                viewFootnoteCtrl.descriptionLanguages.sort();
            }
        };
    });


// WEBPACK FOOTER //
// ./app/taric/footnote/view/footnote-view.js